<div class="debug-panel" [class.collapsed]="!isOpen">
	<div class="debug-header">
		<div class="debug-header-copy" *ngIf="isOpen">
			<div class="title">Data inspector</div>
			<div class="subtitle">Review source, mapped result, and preview details without leaving the mapper.</div>
		</div>

		<button class="toggle-btn" type="button" (click)="togglePanel()">
			{{ isOpen ? 'Collapse' : 'Inspector' }}
		</button>
	</div>

	<div class="debug-body" *ngIf="isOpen">
		<div class="tabs">
			<button *ngFor="let tab of tabs; trackBy: trackByKey" type="button" [attr.data-cy]="'mapper-debug-tab-' + tab.key" [class.active]="activeTab === tab.key" (click)="setTab(tab.key)">
				{{ tab.label }}
			</button>
		</div>

		<ng-container *ngIf="activeTab === 'preview'">
			<div class="viewer-toolbar">
				<button type="button" [class.active]="viewModes.preview === 'pretty'" (click)="setViewMode('preview', 'pretty')">Pretty</button>
				<button type="button" [class.active]="viewModes.preview === 'raw'" (click)="setViewMode('preview', 'raw')">Raw</button>
				<button type="button" (click)="format('preview')">Format</button>
				<button type="button" (click)="copy(getDisplayText('preview'))">Copy</button>
			</div>

			<div class="parse-error" *ngIf="getParseError('preview') as error">
				{{ error }}
			</div>

			<div class="empty-state" *ngIf="!hasContent('preview')">
				No preview response available yet.
			</div>

			<div class="json-shell" *ngIf="hasContent('preview')">
				<pre class="json-pre" *ngIf="viewModes.preview === 'pretty'; else previewRaw">{{ getDisplayText('preview') }}</pre>

				<ng-template #previewRaw>
					<textarea class="json-textarea" [value]="rawDrafts.preview" (input)="onRawChanged('preview', $any($event.target).value)"></textarea>
				</ng-template>
			</div>
		</ng-container>

		<ng-container *ngIf="activeTab === 'source'">
			<div class="viewer-toolbar">
				<button type="button" [class.active]="viewModes.source === 'pretty'" (click)="setViewMode('source', 'pretty')">Pretty</button>
				<button type="button" [class.active]="viewModes.source === 'raw'" (click)="setViewMode('source', 'raw')">Raw</button>
				<button type="button" (click)="format('source')">Format</button>
				<button type="button" (click)="copy(getDisplayText('source'))">Copy</button>
			</div>

			<div class="parse-error" *ngIf="getParseError('source') as error">
				{{ error }}
			</div>

			<div class="empty-state" *ngIf="!hasContent('source')">
				No source payload available yet.
			</div>

			<div class="json-shell" *ngIf="hasContent('source')">
				<pre class="json-pre" *ngIf="viewModes.source === 'pretty'; else sourceRaw">{{ getDisplayText('source') }}</pre>

				<ng-template #sourceRaw>
					<textarea class="json-textarea" [value]="rawDrafts.source" (input)="onRawChanged('source', $any($event.target).value)"></textarea>
				</ng-template>
			</div>
		</ng-container>

		<ng-container *ngIf="activeTab === 'result'">
			<div class="viewer-toolbar">
				<button type="button" [class.active]="viewModes.result === 'pretty'" (click)="setViewMode('result', 'pretty')">Pretty</button>
				<button type="button" [class.active]="viewModes.result === 'raw'" (click)="setViewMode('result', 'raw')">Raw</button>
				<button type="button" (click)="format('result')">Format</button>
				<button type="button" (click)="copy(getDisplayText('result'))">Copy</button>
			</div>

			<div class="parse-error" *ngIf="getParseError('result') as error">
				{{ error }}
			</div>

			<div class="empty-state" *ngIf="!hasContent('result')">
				No mapped result available yet.
			</div>

			<div class="json-shell" *ngIf="hasContent('result')">
				<pre class="json-pre" *ngIf="viewModes.result === 'pretty'; else resultRaw">{{ getDisplayText('result') }}</pre>

				<ng-template #resultRaw>
					<textarea class="json-textarea" [value]="rawDrafts.result" (input)="onRawChanged('result', $any($event.target).value)"></textarea>
				</ng-template>
			</div>
		</ng-container>
	</div>
</div>
